import * as z from 'zod'
import { schemaBoolish } from './zodUtils.js'

export const putInvestorSchema = z.object({
    amountInCash: z.coerce.string().nullish(),
    amountInPercentage: z.coerce.string().nullish(),
    id: z.string().optional(),
    name: z.string(),
    feeLevel: z.coerce.number().nullish(),
    investorAliasId: z.string().optional(),
    investorId: z.string().optional(),
    leo: schemaBoolish.nullish(),
    isSeller: schemaBoolish.nullish(),
    withoutRights: schemaBoolish.nullish(),
    putOption: schemaBoolish.nullish(),
    primaryGuarantor: schemaBoolish.optional(),
})
